
const moduleData = {
  id: "module-5",
  title: "Module 5",
  subtitle: "Moulding character through spiritual education in Brahma Charya",
   cardImage: "/enBanner/m5_banner.jpg",
  pdfPath: '/en/Modules/m5.pdf',
  audio: {
    title: "Vedic Chanting - Placeholder",
    audioUrl: "/en/Audio/m5.mp3",
    duration: "0:00"
  },
  video: {
    id: "g-g1_2_g_0k"
  },
  hero: {
    title: "Module 5",
    subtitle: "Moulding character through spiritual education in Brahma Charya",
    description: "Content for this module is coming soon.",
    buttonText: "Explore",
    bgImage: "/enBanner/m5_banner.jpg",
    bgAlt: "Placeholder"
  },
  pages: [
    {
      pageId: 'definition',
      title: 'Definition',
      definition: {
        sectionLabel: "Definition",
        title: "What is Moulding character through spiritual education in Brahma Charya?",
        text: "Placeholder text.",
        quote: {
          sanskrit: "",
          meaning: "",
          origin: ""
        },
        description: "Placeholder description.",
        source: "",
        image: "",
        imageAlt: ""
      }
    },
    {
      pageId: 'quiz',
      title: 'Quiz',
      quiz: {
        questions: [
          {
            question: "What is the primary goal of the Brahmacharya (student) stage?",
            options: ["Accumulating wealth", "Moulding character through spiritual education", "Traveling the world", "Practicing only rituals"],
            answer: "Moulding character through spiritual education"
          },
          {
            question: "Which of the following is NOT a core daily discipline recommended for Brahmacharya Āśrama?",
            options: ["Chanting Gayatri Mantra three times a day", "Respecting parents and elders", "Eating only sāthwic (pure) food", "Earning money"],
            answer: "Earning money"
          },
          {
            question: "What is the significance of the “Naming Ceremony” (Nāmakaraṇa) in the Brahmacharya stage?",
            options: ["It is just a family tradition", "It marks the beginning of spiritual journey and connects the child to Vedic culture", "It is only for boys", "It is performed at marriage"],
            answer: "It marks the beginning of spiritual journey and connects the child to Vedic culture"
          },
          {
            question: "Which of the following is considered a “sin of the tongue” to be avoided in Brahmacharya Āśrama?",
            options: ["Speaking the truth", "Falsehood", "Respecting elders", "Eating fruits"],
            answer: "Falsehood"
          },
          {
            question: "What is the significance of Akshara Abhyasa in Brahmacharya Āśrama?",
            options: ["It is a sports event", "It is the initiation into learning, beginning with sacred syllables", "It is a festival", "It is a graduation ceremony"],
            answer: "It is the initiation into learning, beginning with sacred syllables"
          },
        ]
      }
    },
    {
      pageId: 'feedback',
      title: 'Feedback',
      feedback: {}
    }
  ]
};

export { moduleData };
